import { Injectable } from "@angular/core";
import { Subject } from "rxjs";
import { landingClickState } from "../../components/landingPage/landingPage.component";

@Injectable()
export class LandingPageClickStateService {
    public subscriber: Subject<landingClickState> = new Subject<landingClickState>();





}